import Vue from 'vue'
import Vuex from 'vuex'

import deal from './deal.module'
import user from './user.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    deal,
    user
  }
})